<template>
  <div class="content-block" :class="{'is-premium': isPremium}">
    <div class="content-block-title">{{$lang.messages.settings.title}}</div>
    <div class="content-block-subtitle">{{$lang.messages.settings.kid_info.title}}</div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="kidsname" class="form-label">{{$lang.messages.settings.kid_info.kid_name}}</label>
          <input id="kidsname" type="text" :value="kidname"
                 @input="updateSettings('kidName', $event.target.value)" placeholder="Enter your kids name" class="form-control">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">{{$lang.messages.settings.kid_info.kid_age}}</label>
          <label class="radio-wrapper" :class="{active: kidage === '5-8'}">
            <input name="kidsAge" type="radio"  class="radio-input" value="5-8" :checked="kidage === '5-8'" @change="updateSettings('kidAge', $event.target.value)">
            <span class="radio-check"></span>
            <span class="radio-label"><strong>5-8</strong>{{$lang.messages.years}}</span>
          </label>
          <label class="radio-wrapper" :class="{active: kidage === '9-12'}">
            <input name="kidsAge" type="radio"  class="radio-input" value="9-12" :checked="kidage === '9-12'" @change="updateSettings('kidAge', $event.target.value)">
            <span class="radio-check"></span>
            <span class="radio-label"><strong>9-12</strong>{{$lang.messages.years}}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="content-block-subtitle">{{$lang.messages.settings.unlock_method.title}} <span v-tooltip="$lang.messages.settings.unlock_method.tooltip" class="info-icon"></span></div>
    <div class="flex flex-wrap mb-1">
      <label class="radio-wrapper -large" :class="{active: unlockMethodSettings === 'math'}">
        <input name="unlockMethod" type="radio"  class="radio-input" value="math" :checked="unlockMethodSettings === 'math'" @change="updateUnlockPassword($event.target.value)">
        <span class="radio-header">
          <span class="radio-check"></span>
          <span class="radio-label -middle">{{$lang.messages.settings.unlock_method.math}}</span>
        </span>
        <span class="radio-text -absolute">{{$lang.messages.settings.unlock_method.default}}</span>
        <span class="radio-text">{{$lang.messages.settings.unlock_method.example}}</span>
        <span class="radio-label -large">2 x 9 = ?</span>
        <span class="text-thin text-sm text-muted">{{$lang.messages.settings.unlock_method.math_description}}</span>
      </label>
      <label class="radio-wrapper -large" :class="{active: unlockMethodSettings === 'pass'}" @click="showLoginModal">
        <input name="unlockMethod" type="radio" class="radio-input" value="pass" :disabled="user && !user.email" :checked="unlockMethodSettings === 'pass'" @change="updateUnlockPassword($event.target.value)">
        <span class="radio-header">
          <span class="radio-check"></span>
          <span class="radio-label -middle">{{$lang.messages.settings.unlock_method.password}}</span>
        </span>
        <span v-if="user && !user.email" class="radio-text -absolute">{{$lang.messages.need_sign_in}}</span>
        <InputPassword v-if="user && user.email"
                       :value="password"
                       @changepassword="changeUserPassword"
                       :disabled="unlockMethodSettings !== 'pass'"
        />
        <span class="flex-v-center" v-if="user && !user.email">
          <span class="radio-text">{{$lang.messages.settings.unlock_method.for_set_pas}}</span>
          <button class="btn btn-outline" @click.prevent="showLoginModal">{{$lang.messages.sign_in}}</button>
        </span>
        <span class="mt-1 text-thin text-sm text-muted">{{$lang.messages.settings.unlock_method.password_description}}</span>
      </label>
    </div>
    <div class="content-block-item">
      <div class="content-block-subtitle">{{$lang.messages.settings.lock_configuration.title}} <span v-tooltip="$lang.messages.settings.lock_configuration.tooltip" class="info-icon"></span></div>
      <div class="row">
        <div class="col-lg-4">
          <div class="flex-between flex-v-center mb-xs-1">
            <div class="text-md">{{$lang.messages.settings.lock_configuration.lock_start}}</div>
            <div>
              <Checkbox :checkboxModel="{'lockOnStart':lockOnStart}" @changecheckbox="updateSettings"/>
            </div>
          </div>
          <div class="text-thin">{{$lang.messages.settings.lock_configuration.lock_start_desc}}</div>
        </div>
        <div class="col-lg-4">
          <div class="block-separator-left" :class="{'show-premium-popup': !isPremium}" @click.stop="showPremiumPopup('autoLock')">
            <div class="flex-between flex-v-center mb-xs-1">
              <div class="text-md">{{$lang.messages.settings.lock_configuration.auto_lock}}&nbsp; <span v-if="!isPremium" class="label-premium">{{$lang.messages.premium}}</span></div>
              <div>
                <v-select
                    :label="autolockOptions.label"
                    :value="autolockOptions.find(item => item.value === autoLock)"
                    :options="autolockOptions"
                    :clearable="false"
                    :disabled="!isPremium"
                    @input="changeAutoLock">
                  <template slot="open-indicator">
                    <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
                    </svg>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="text-thin">{{$lang.messages.settings.lock_configuration.auto_lock_desc}}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="block-separator-left " :class="{'show-premium-popup': !isPremium}" @click.stop="showPremiumPopup('alwaysOnTop')">
            <div class="flex-between flex-v-center mb-xs-1">
              <div class="text-md">{{$lang.messages.settings.lock_configuration.always_top}}&nbsp; <span v-if="!isPremium" class="label-premium">{{$lang.messages.premium}}</span></div>
              <div>
                <Checkbox :disabled="!isPremium" :checkboxModel="{'alwaysTop':alwaysTop}" @changecheckbox="updateSettings"/>
              </div>
            </div>
            <div class="text-thin">{{$lang.messages.settings.lock_configuration.always_top_desc}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="content-block-item" :class="{'show-premium-popup': !isPremium}" @click.stop="showPremiumPopup('remoteLock')">
          <div class="content-block-subtitle">{{$lang.messages.settings.remote_lock.title}}&nbsp; <span v-if="!isPremium" class="label-premium">{{$lang.messages.premium}}</span><span v-tooltip="$lang.messages.settings.remote_lock.tooltip" class="info-icon"></span></div>
          <div class="flex-between flex-v-center flex-wrap">
            <div class="flex-v-center">
              <span class="flex-center remote-lock-icon">
                <i v-if="!kidsMode" class="icon-unlock"></i>
                <i v-if="kidsMode" class="icon-lock"></i>
              </span>
              <div class="ml-1">
                <div>{{kidsMode ? $lang.messages.locked : $lang.messages.unlocked}}</div>
                <div class="text-thin text-sm">{{isLocked ? 'KidsMode is Unavailable' : 'KidsMode is Available'}}</div>
              </div>
            </div>
            <button class="mt-1 mb-1 btn btn-outline" :disabled="!isPremium" @click="toggleLock">{{kidsMode ? 'UnLock' : 'Lock'}} now</button>
            <div class="flex flex-wrap flex-end flex-v-center" :class="{'w-100': isUnAvailableTime && checkLock}" v-if="isLocked || (!showGiveBonusTime && dailyLimitUsed >= todayDailyLimit)">
              <button v-if="checkLock && !showGiveBonusTime && dailyLimitUsed >= todayDailyLimit" class="btn btn-outline m-05 ml-auto-xs" :disabled="!isPremium" @click="showGiveBonusTime = true">{{$lang.messages.settings.remote_lock.give_time}}</button>
<!--              <div v-if="showGiveBonusTime && checkLock" class="flex flex-wrap flex-end w-100-xs">
                <v-select class="feature-lock-time-select" :clearable="false" v-model="addTime" :options="addTimeOptions" :reduce="item => item.value" label="label">
                  <template slot="open-indicator">
                    <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
                    </svg>
                  </template>
                </v-select>
                <button class="btn btn-main ml-1" :disabled="!isPremium" @click="addMoreTime">Ok</button>
              </div>-->
              <div v-if="isLocked" class="mt-1 text-center text-sm">
                {{ $lang.messages.settings.remote_lock.unlock_by_unavailable_settings }}
              </div>
            </div>
          </div>
        </div>
        <div class="content-block-item" :class="{'show-premium-popup': !isPremium}" @click.stop="showPremiumPopup('dailyLimit')">
          <div class="flex-between flex-v-center mb-2">
            <div class="content-block-subtitle mb-0">{{$lang.messages.settings.daily_limit.title}}&nbsp; <span v-if="!isPremium" class="label-premium">{{$lang.messages.premium}}</span><span v-tooltip="$lang.messages.settings.daily_limit.tooltip" class="info-icon"></span></div>
            <v-select
                :disabled="!isPremium"
                :label="dailyLimitOptions.label"
                :value="dailyLimitOptions.find(item => item.value >= dailyLimit)"
                :clearable="false"
                :options="dailyLimitOptions" @input="changeDailyLimit">
              <template slot="open-indicator">
                <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
                </svg>
              </template>
            </v-select>
          </div>
          <div class="progress w-100 mb-1" :class="{blocked: !isPremium}">
            <div class="progress-label" v-if="todayDailyLimit < 86400">
              <span class="text-bold text-md">{{ isPremium ? Math.floor(dailyLimitUsed / 60) : 0 }}</span>
              <span class="text-thin">m</span>
            </div>
            <div class="progress-label" v-if="todayDailyLimit < 86400">
              <span class="text-bold text-md">{{ Math.floor((todayDailyLimit || dailyLimit) / 60) }}</span>
              <span class="text-thin">m</span>
            </div>
            <div class="progress-percent" v-if="todayDailyLimit < 86400" :style="{width: isPremium ? dailyLimitUsed / todayDailyLimit * 100 +'%' : 0}"></div>
          </div>
          <p>{{$lang.messages.settings.daily_limit.block_description}}</p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="content-block-item">
          <div class="content-block-subtitle">{{$lang.messages.settings.unavailable.title}} <span v-if="!isPremium" class="label-premium">Premium</span> <span v-tooltip="$lang.messages.settings.unavailable.tooltip" class="info-icon"></span></div>
          <div :class="{'show-premium-popup': !isPremium}" @click.stop="showPremiumPopup('RestrictedTime')">
            <table class="table table-schedule">
              <tbody>
                <tr v-for="time in availableTime" :key="time.id">
                  <td class="td-checkbox">
                    <Checkbox :disabled="!isPremium" :checkboxModel="{[time.name]:time.isActive}" @changecheckbox="changeschedule"/>
                  </td>
                  <td class="td-day">{{time.name}}</td>
                  <td>
                    <span>
                      {{time.allDay ? 'All Day' : ''}}
                      <span v-for="period in time.periods" :key="period.id" class="time-period" :class="{'-last': period.id === time.periods.length - 1 }">{{period.from}} - {{period.to}}</span>
                    </span>
                  </td>
                  <td class="text-right"><button class="btn-icon" :disabled="!isPremium" @click="openEditTimeModal(time)"><i class="icon-edit"></i></button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <EditTimeModal v-if="showEditTimeModal"
                   v-on:closeedittimemodal="showEditTimeModal = false"
                   v-on:editunavailabletime="editUnavailableTime"
                   :dayId="editTimeDayId"
                   :day="editTimeDay"
                   :time="editTimeModalCurrent"
                   :additionalTime="editTimeModalCurrentAdditional"
                   :blockDay="editTimeModalBlockDay"
                   :availableTime="availableTime"/>
  </div>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import Checkbox from './Checkbox'
import EditTimeModal from "./EditTimeModal"
import InputPassword from "./InputPassword"
import { reportEvent } from "@/helpers/utils"

Vue.component('v-select', vSelect)

export default {
  name: 'Settings',
  props: ['user', 'password', 'kidname', 'kidage', 'isLocked', 'unlockMethod', 'lockOnStart', 'kidsMode', 'isUnAvailableTime', 'isPremium', 'autoLock', 'alwaysTop', 'availableTime', 'dailyLimit', 'todayDailyLimit', 'dailyLimitUsed'],
  data: function (){
    return {
      unlockMethodSettings: this.unlockMethod,
      locked: this.isLocked,
      showEditTimeModal: false,
      showGiveBonusTime: false,
      editTimeDayId: null,
      editTimeDay: null,
      editTimeModalCurrent: null,
      editTimeModalCurrentAdditional: null,
      editTimeModalBlockDay: null,
      checkLock: false,
      addTime: 1800,
      addTimeOptions: [{
        label: '+ 30 min',
        value: 1800 /*seconds*/
      },
        {
          label: '+ 1 hour',
          value: 3600
        },
        {
          label: '+ 2 hours',
          value: 7200
        }],
      autolockOptions: [
        {
          label: 'Off',
          value: 0,
        },
        {
          label: '30 sec',
          value: 30,
        },
        {
          label: '1 min',
          value: 60,
        },
        {
          label: '5 min',
          value: 300,
        },
        {
          label: '10 min',
          value: 600,
        },
        {
          label: '30 min',
          value: 1800,
        }
      ],
      dailyLimitOptions: [
        {
          label: '30 min',
          value: 1800,
        },
        {
          label: '1 hour',
          value: 3600,
        },
        {
          label: '1h 30m',
          value: 5400,
        },
        {
          label: '2 hours',
          value: 7200,
        },
        {
          label: '3 hours',
          value: 10800,
        },
        {
          label: '4 hours',
          value: 14400,
        },
        {
          label: 'Unlimited',
          value: 86400,
        },
      ],
    }
  },
  methods: {
    toggleLock () {
      this.$emit('updatesettings', {kidsMode: !this.kidsMode});
    },
    addMoreTime() {
      this.showGiveBonusTime = false
      this.$emit('updatesettings', {'todayDailyLimit': this.todayDailyLimit + this.addTime})
    },
    /**
     * @desc If selected math - change it, if password - check password field
     * @param value
     */
    updateUnlockPassword(value) {
      this.unlockMethodSettings = value;
      if (this.password.length > 0 && value !== 'math') {
        this.updateSettings('unlockMethod', value)
      } else {
        this.updateSettings('unlockMethod', 'math')
      }
    },
    updateSettings(keyName, value) {
      reportEvent('changeSettings', {[keyName]: value}, {'isPremium': this.isPremium, 'isRemote': localStorage.getItem('isRemote')})
      this.$emit('updatesettings', {[keyName]: value});
    },
    showPremiumPopup (setting) {
      if(!this.isPremium){
        this.$emit('openonlypremiummodal')
        reportEvent('tryChangeSettingsWithNoPremium', {'tryChange': setting, 'isRemote': localStorage.getItem('isRemote')})
      }
    },
    changeschedule(day, value) {
      const temp = this.availableTime.find(item => item.name === day)
      temp.isActive = value;
      this.checkLockState()
      this.$emit('updatesettings', {availableTime: this.availableTime});
    },
    changeAutoLock(value) {
      if (!this.isPremium) {
        this.$emit('openonlypremiummodal')
      } else {
        this.updateSettings('autoLock', value.value)
      }
    },
    changeDailyLimit(value){
      this.updateSettings('dailyLimit', value.value)
      this.updateSettings('todayDailyLimit', value.value)
    },
    unlock(){
      this.checkLock = true
    },
    openEditTimeModal(time){
      switch (time.name){
        case 'Su': this.editTimeDay = 'Sunday'
          break
        case 'Mo': this.editTimeDay = 'Monday'
          break
        case 'Tu': this.editTimeDay = 'Tuesday'
          break
        case 'We': this.editTimeDay = 'Wednesday'
          break
        case 'Th': this.editTimeDay = 'Thursday'
          break
        case 'Fr': this.editTimeDay = 'Friday'
          break
        case 'Sa': this.editTimeDay = 'Saturday'
          break
      }
      this.editTimeDayId = time.id
      this.editTimeModalCurrent = time.periods || null
      this.editTimeModalBlockDay = time.allDay
      this.editTimeModalCurrentAdditional = time.periods && time.periods.length > 1 || false
      this.showEditTimeModal = true
    },
    editUnavailableTime(time){
      const previousDay = this.availableTime.find(item => item.id === time.id)
      Object.assign(previousDay, time)

      this.$emit('updatesettings', {availableTime: this.availableTime})
      this.showEditTimeModal = false
      this.checkLockState()
    },
    checkLockState() {
      const todayDate = Date.now()
      let isUnAvailableTime = this.isUnAvailableTime;
      if ((this.availableTime &&
          (this.availableTime[this.getDayFromDate(todayDate)].isActive && this.availableTime[this.getDayFromDate(todayDate)].allDay)) ||
          (this.availableTime[this.getDayFromDate(todayDate)].isActive && this.checkisUnAvailableTime(this.availableTime[this.getDayFromDate(todayDate)]))) {
        isUnAvailableTime = true
      } else {
        this.checkLock = false
        isUnAvailableTime = false
      }
      if (isUnAvailableTime !== this.isUnAvailableTime) {
        this.updateSettings('isUnAvailableTime', isUnAvailableTime)
      }
    },
    showLoginModal(e){
      if (!this.user.email){
        e.preventDefault()
        this.$emit('showloginmodal');
      }
    },
    changeUserPassword(value){
      if(value.length === 0){
        this.updateUnlockPassword('math')
      }
      this.updateSettings('password', value)
      this.updateUnlockPassword('pass')
    },
    checkisUnAvailableTime(unavailable) {
      const today = new Date().getTime()
      const currentDate = new Date()
      const splitedTime = (timeString) => {

        let hours
        if(timeString.split(/:| /)[2] === 'PM'){
          if(timeString.split(/:| /)[0] === '12'){
            hours = parseInt(timeString.split(/:| /)[0])
          } else {
            hours = parseInt(timeString.split(/:| /)[0]) + 12
          }
        } else {
          hours = parseInt(timeString.split(/:| /)[0])
        }
        return {
          min: parseInt(timeString.split(/:| /)[1]),
          hour: hours
          // hour: timeString.split(/:| /)[2] === 'PM' ? parseInt(timeString.split(/:| /)[0]) + 12 : parseInt(timeString.split(/:| /)[0]),
        }
      }
      let periodMainFrom, periodMainTo
      if(unavailable.periods) {
        periodMainFrom = currentDate.setHours(splitedTime(unavailable.periods[0].from).hour, splitedTime(unavailable.periods[0].from).min)
        periodMainTo = currentDate.setHours(splitedTime(unavailable.periods[0].to).hour, splitedTime(unavailable.periods[0].to).min)
      }
      if (unavailable.periods && unavailable.periods[1]) {
        const periodAddFrom = currentDate.setHours(splitedTime(unavailable.periods[1].from).hour, splitedTime(unavailable.periods[1].from).min)
        const periodAddTo = currentDate.setHours(splitedTime(unavailable.periods[1].to).hour, splitedTime(unavailable.periods[1].to).min)
        return (today > periodMainFrom && today < periodMainTo) || (today > periodAddFrom && today < periodAddTo)
      } else {
        return (today > periodMainFrom && today < periodMainTo)
      }
    },
    getDayFromDate(stamp){
      const date = new Date(stamp)
      return date.getDay()
    }
  },
  components: {
    EditTimeModal,
    Checkbox,
    InputPassword
  }
}
</script>

